// extracted by mini-css-extract-plugin
export default {"err":"style_err__CYv-K"};